import React from 'react'
import { Dropdown } from 'react-bootstrap'
import useCurrentUser from '../../../hooks/use-current-user'
import BusyModal from '../../modals/busy'
import moment from 'moment'
import useSeriesDelete from './use-series-delete'
import { get } from 'lodash'

const ExperiencesDuplicateMenu = ({
    experience = {},
}) => {
    const { isAdmin } = useCurrentUser()

    const { deleteSeries, isDeletingSeries } = useSeriesDelete({ seriesId: experience.seriesId })

    const series = get(experience, 'series', {})

    if (!series) {
        return null
    }

    const { endDate } = series

    if (isDeletingSeries) {
        return (
            <BusyModal title='Removing series...' />
        )
    }

    //  Deleting a series only deletes courses that haven't occurred yet
    const canRemoveByDate = moment().isSameOrBefore(endDate, 'day')
    const canRemove = canRemoveByDate && isAdmin

    return (
        <Dropdown.Item
            onClick={() => deleteSeries()}
            disabled={!canRemove || isDeletingSeries}
        >
            Remove Series
        </Dropdown.Item>
    )
}

export default ExperiencesDuplicateMenu